import { setDiagnosis } from "@/stores/features/diagnosisSlice";
import { useAppDispatch } from "@/stores/hooks";
import { diagnosisService } from "@/stores/services/diagnosisServices";
import { decryptId } from "@/utils/utilsMethods";
import { skipToken } from "@reduxjs/toolkit/query";
import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";

export function useDiagnosisData() {
  const dispatch = useAppDispatch();
  const { idCompany } = useParams();
  const [searchParams] = useSearchParams();

  const diagnosisParam = searchParams.get("diagnosis");
  const diagnosisId = diagnosisParam
    ? parseInt(decryptId(diagnosisParam))
    : undefined;
  const companyId = parseInt(decryptId(idCompany ?? ""));

  const { data: diagnosisData } = diagnosisService.useFindByIdQuery(
    diagnosisId ? { diagnosisId } : skipToken
  );

  useEffect(() => {
    if (diagnosisData) {
      dispatch(setDiagnosis(diagnosisData.diagnosis));
    }
  }, [diagnosisData, dispatch]);

  return {
    diagnosisData,
    companyId,
    diagnosisId,
  };
}
